import mutations from './mutations'
import getters   from './getters'
import actions   from './actions'

export default {
  namespaced: true,
  mutations,
  getters,
  actions,

  state: {
    movieList: [],
    availableDays: [],
    availableTimes: [],
    availableRange: [],
    selectedMovie: null
  }
}
